export default () => ({
  layoutLoggedContentConntainer: {
    display: 'flex',
    minHeight: 'inherit',
    paddingBottom: '45px !important',
    paddingTop: '45px !important',
  },
});
